import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Pulse from 'react-reveal/Pulse';

const styles = theme => ({
    root:{
        margin: '30px 0px'
    }
})
class Valuable extends React.Component{
    render(){
        const { classes } = this.props;
        return(
            <div className={classes.root}>
            <Grid container
                direction="row"
                justify="center"
                alignItems="center" id="section3"
                className="valuable"
                // spacing={16}
            >
                <Grid item md={6} xs={12}>
                    <Pulse count={2}>
                        <div className='clipwrapper value'>
                            <p>Average monthly spending power<br />
                                <span>$400</span>
                            </p>
                        </div>
                    </Pulse>
                </Grid>
                <Grid item md={6} xs={12} style={{ marginTop: 20, paddingLeft: 16 }}>
                    <h2 style={{ color: '#ed7123'}}>Very valuable</h2>
                    <p>• They are valuable to you and valuable to us.<br/>• They read our content.<br/>• They buy your products.</p>
                </Grid>              
            </Grid>
            <div className="gradient-divider"></div>
            <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className="count"
                // spacing={16} 
                style={{ marginTop: '2em' }}
                
            >
                 <Grid item md={12} xs={12}>
                 <h2 style={{ padding: '30px 0px 10px', color: '#ed7123', fontSize: 30 }}>They Love Duwun</h2>
                    <p>We cover news, entertainment, lifestyle, sports and tech in millennial way and they love it.</p>
                    </Grid>
                   
                    <Grid item md={4} xs={12} className="count-view">
                        <Icon className="customIcon">public</Icon>
                        <h3><span data-sr="count 3.5">3.5</span> million</h3>
                        <p>Unique monthly web visitor</p>
                    </Grid>   
                    <Grid item md={4} xs={12} className="count-view">
                        <Icon className="customIcon">date_range</Icon>
                        <h3><span data-sr="count 50.4">50.4</span> million</h3>
                        <p>Video views a month</p>
                    </Grid>              
                    <Grid item md={4} xs={12} className="count-view">
                        <Icon className="customIcon">people</Icon>
                        <h3><span data-sr="count 70.2">70.2</span> %</h3>
                        <p>Returning visitors.</p>
                    </Grid>   
               
            </Grid>      
        </div>
        )
    }
}
export default withStyles(styles)(Valuable);